<template>
    <div class="border-t borger-dove-gray-100 w-full py-4">
        <ais-panel>
            <template v-slot:header>
                <button @click="isOpen = !isOpen" class="flex justify-between items-center w-full pb-4">
                    <span class="font-bold">{{ label }}</span>
                    <div data-caret-icon class="ml-auto pr-4">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true"
                            class="h-4 w-4 transition-transform duration-300 ease-in-out"
                            :class="{ 'rotate-180': isOpen }">
                            <path
                                d="M241 337c-9.4 9.4-24.6 9.4-33.9 0L47 177c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 337z" />
                        </svg>
                    </div>
                </button>
            </template>
            <transition enter-from-class="opacity-0" leave-to-class="opacity-0"
                enter-active-class="transition duration-100" leave-active-class="transition duration-100">
                <template v-if="isOpen" class="max-h-screen overflow-hidden">
                    <ais-refinement-list :attribute="props.attribute" :sort-by="['name:asc']" searchable :limit="150">
                        <template v-slot="{
                            items,
                            refine,
                            createURL,
                            searchForItems,
                        }">
                            <input v-if="searchForItems == true" @input="searchForItems($event.currentTarget.value)">
                            <ul>
                                <li v-for="(item) in processedItems(items).slice(0, itemsToShow)" :key="item.value"
                                    class="flex items-center gap-2 pb-2">
                                    <input type="checkbox" :checked="item.isRefined" @change="refine(item.value)">
                                    <a :href="createURL(item)" :style="{ fontWeight: item.isRefined ? 'bold' : '' }"
                                        @click.prevent="refine(item.value)" class="flex gap-2">
                                        <span v-html="item.value" class="text-base" />
                                        <span
                                            class="text-sm text-gray-700 border border-dove-gray-100 rounded-full px-2">
                                            {{ item.count.toLocaleString() }}
                                        </span>
                                    </a>
                                </li>
                            </ul>
                            <button v-if="itemsToShow < items.length" @click="showMore(items)"
                                class="underline text-sm text-gray-900">
                                {{ $t('message.typesense.panel.showMore', { quantity: items.length - itemsToShow }) }}
                            </button>
                            <button v-else-if="itemsToShow > 7" @click="showLess"
                                class="underline text-sm text-gray-900">
                                {{ $t('message.typesense.panel.showLess') }}
                            </button>
                        </template>
                    </ais-refinement-list>
                </template>
            </transition>
        </ais-panel>
    </div>
</template>

<script setup>
import { defineEmits } from 'vue'

const future = { preserveSharedStateOnUnmount: true };
import { ref, defineProps } from 'vue'
import { AisInstantSearch, AisCurrentRefinements, AisAutocomplete, AisSearchBox, AisSortBy, AisToggleRefinement, AisConfigure, AisPanel, AisHits, AisHighlight, AisRefinementList, AisPagination, AisHitsPerPage } from 'vue-instantsearch/vue3/es';
import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";
const itemsToShow = ref(7)
const isOpen = ref(true);

const props = defineProps({
    attribute: {
        type: String,
        required: true
    },
    label: {
        type: String,
        required: true
    }
})

const sortingOrders = {
  frame_width: {
    "Narrow": 1,
    "Medium": 2,
    "Wide": 3,
    "Extra Wide": 4
  },
  rabbet_depth: {
    "Shallow": 1,
    "Medium": 2,
    "Deep": 3,
    "Extra Deep": 4
  }
};

// Only applies sorting for 'frame_width' and 'rabbet_depth'
const processedItems = (items) => {
  if (
    props.attribute === 'frame_type' ||
    props.attribute === 'material' ||
    props.attribute === 'color_family' ||
    props.attribute === 'finish' ||
    props.attribute === 'substrates' ||
    props.attribute === 'art_sizes'
  ) {
    return [...items].sort((a, b) => b.count - a.count);
  }

  if (props.attribute === 'color' || props.attribute === 'decor_style') {
    if (items.length > 7 && itemsToShow.value === items.length) {
      return [...items].sort((a, b) => a.label.localeCompare(b.label));
    } else {
      return [...items].sort((a, b) => b.count - a.count);
    }
  }
  const order = sortingOrders[props.attribute];
  if (!order) return items;

  return [...items].sort((a, b) => {
    const nameA = a.label.split(":")[0].trim();
    const nameB = b.label.split(":")[0].trim();
    return (order[nameA] || 99) - (order[nameB] || 99);
  });
};


const showMore = (items) => {
    itemsToShow.value = items.length;
};

const showLess = () => {
    itemsToShow.value = 7;
};
</script>
